// Lib
import React, { ReactElement } from 'react';

// Components
import TiptapToggleMarkTool from './TiptapToggleMarkTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const TiptapUnderlineTool = (props: ToolbarToolProps): ReactElement => (
    <TiptapToggleMarkTool {...props} mark="underline" />
);

export default TiptapUnderlineTool;
